import { useEffect, useState } from 'react';
import React from 'react'
import PropTypes from 'prop-types';
import moment from "moment";

import { makeStyles, DialogContent, DialogContentText, Dialog, Typography, DialogActions, Button } from '@material-ui/core';

import SelectDate from '../../Steppers/NewConference/selectDate'
import Info from '../../Steppers/NewConference/info'
import Attendees from '../../Steppers/NewConference/addAttendees'
import Cases from '../../Steppers/NewConference/addCases'
import Success from '../../Steppers/NewConference/success'
import { blue } from '@material-ui/core/colors';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

function getSteps() {
  return ['Conference Info', 'Select Date', 'Add Attendees', 'Add Cases'];
};

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});

const initial = {
  label: '',
  description: '',
  core: {},
  date: '',
  time: '',
  cases: [],
  attendees: [],
};

const NewConfDialog = (props) => {

  const { handleClose, open } = props;
  const [state, setState] = React.useState(initial);
  const [newItem, setNewItem] = React.useState(initial)
  const [activeStep, setActiveStep] = React.useState(0);
  const [errorMessage, setErrorMessage] = useState('');

 

  const { patientssearch, onAdd, employeeSearch, coreData } = props;


  useEffect(() => {
  }, [state])

  // const handleChangeInput = name => ({ target: { value } }) => {
  //   setNewItem({ ...newItem, [name]: value })
  //   console.log(newItem);
  // }

  const steps = getSteps();

  const handleNext = (e) => {
    if (state.label.length < 1) {
      setErrorMessage('Label cannot be blank')
    } else if (state.description.length < 1) {
      setErrorMessage('Description cannot be blank')
    } else if (state.core.id === undefined) {
      setErrorMessage('You must select a core')
    } else {
      e.preventDefault();
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const reset = () => {
    setActiveStep(0);
  };

  const handleSubmit = (state) => {
    if (!state.date) {
      let defaultdate = new Date();
      let defaultdateFormatted = moment(defaultdate).format("YYYY-MM-DD")
      state.date = defaultdateFormatted;
    }
    if (!state.time) {
      let defaultTime = '09:00:00.000';
      state.time = defaultTime;
    }
    onAdd(state)
    console.log("handleSubmit -> state", state)
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <Info state={state} setState={setState} errorMessage={errorMessage} coreData={coreData} />;
      case 1:
        return <SelectDate state={state} setState={setState} />;
      case 2:
        return <Attendees employeeSearch={employeeSearch} state={state} setState={setState} />;
      case 3:
        return <Cases patientssearch={patientssearch} state={state} setState={setState} />;
      case 4:
        return <Success />;
    }
  };


  return (
    <Dialog className="NewConfDialog" onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <MuiDialogTitle className="dialog-header" >
        <IconButton aria-label="close" edge='end' className="dialog-close-btn-cont" onClick={handleClose}>
          <CloseIcon className="dialog-close-btn" />
        </IconButton>
        </MuiDialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography component={'span'}>{getStepContent(activeStep)}</Typography>
        </DialogContentText>
      </DialogContent>
      {activeStep === steps.length ? 
            <DialogActions className="ButtonRow">
              <Button
              onClick={reset}
            >
              Add Another
              </Button> 
              <Button
              onClick={handleClose}
              className="next-button"
            >
              Finish
              </Button> 
              </DialogActions>: 
      <DialogActions className="ButtonRow">
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
        >
          Back
          </Button>

        <Button
          variant="contained"
          color="primary"
          className="next-button"
          onClick={activeStep === steps.length - 1 ? () => handleSubmit(state) : handleNext}
        >
          {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
        </Button>
      </DialogActions>
    }
    </Dialog>
  )
};


export default NewConfDialog;